import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComplianceComponent } from './pages/compliance/compliance.component';



const routes: Routes = [
  //{ path: '', pathMatch: 'full' },
  { path: '', redirectTo: '/compliance', pathMatch: 'full' },
  { path: 'compliance', children: [
    { path: '', component: ComplianceComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
